const headerComponent = () => ({
  observer: null,

  init() {
    const announcementBar = document.querySelector('.announcement-bar-section:has(.announcement-bar--sticky');
    this.observer = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        const target = entry.target;
        const label = target.classList.contains('announcement-bar-section')
          ? 'announcement-bar'
          : 'header';
        document.documentElement.style.setProperty(
          `--${label}-size`,
          `${target.offsetHeight}px`
        );
      });
    });

    if (announcementBar) {
      this.observer.observe(announcementBar);
    }

    this.observer.observe(this.$el);
  },

  destroy() {
    if (this.observer) {
      this.observer?.disconnect();
    }

    this.observer = null;
  },
});

export default headerComponent;
